window.addEventListener('load', () => {
  const form = document.querySelector('.name-the-fish form');

  const observer = new MutationObserver(() => {
    if (!document.contains(form)) {
      const target = document.querySelector('.name-the-fish__content');
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - 100,
        behavior: 'smooth',
      });
      observer.disconnect();
    }
  });

  observer.observe(document.querySelector('.name-the-fish'), { childList: true, subtree: true });
});
